module.exports = __webpack_public_path__ + "img/eb-full-optimized.62ecb30a.svg";